import { ReactNode, useEffect, useState } from "react";
import { IPartner } from "../../../../types/partners.type";
import { getPartnersById, updatePartners } from "../../../../common/services/partners.api";
import { initialState, PartnerDashboardContext } from "./PartnerDashboard.context";

type Props = {
  children: ReactNode,
  partnerId: string
}

export function PartnerDashboardProvider(props: Props) {

  const [partner, setLead] = useState<IPartner>(initialState.partner)

  useEffect(() => {
    async function loadLead(partnerId: string) {
      const result = await getPartnersById(partnerId)

      if (result.ok) {
        setLead(result.data as IPartner)
      }
    }

    loadLead(props.partnerId)
  }, [props.partnerId])

  async function savePartner(dataToSave: IPartner) {
    try {
      const { ok, data, errors } = await updatePartners(partner._id as string, dataToSave)

      if (ok && data) {
        setLead(data as IPartner)
        return { ok, data: data as IPartner, errors: (errors as [{ message: string, path: string[] }]) }
      }

      return { ok, data: data as IPartner, errors: errors as [{ message: string, path: string[] }] }
    } catch (err) {
      return {
        ok: false,
        data: dataToSave,
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        errors: [{ message: (err as any).message, path: [] }]
      }
    }
  }

  const theState = { partner, savePartner }

  return (
    <PartnerDashboardContext.Provider value={theState}>
      {props.children}
    </PartnerDashboardContext.Provider>
  )
}